export default __webpack_public_path__ + "static/media/Armstraps of the Wells of Night.df4f5ce7.jpg";